/**
 * The header notice shown after AHU 1 reports that a release went live.
 *
 * @param {object=} release The release reported by AHU 1
 * @param {function} saveAndReload Saves pending project changes in AHU 1 and reloads the page
 * @return {object|null}
 */
export const noticeForRelease = (release, saveAndReload) =>
    release ? { release, saveAndReload, reloading: false } : null;

/** The notice to show after a release is reported: the one already shown stays until the page is reloaded. */
export const noticeAfterRelease = (current, release, saveAndReload) =>
    current || noticeForRelease(release, saveAndReload);

export const canRequestReload = notice => !!notice && !notice.reloading;

export const withReloadRequested = notice => ({ ...notice, reloading: true });

export const withReloadCancelled = notice => ({ ...notice, reloading: false });
